// extracted by mini-css-extract-plugin
export default {"company_logo":"styles_company_logo__P2cwp"};